<template>
    <div>
        <div class="card mb-4">
            <div class="card-header">
                <i class="fa fa-folder-o""></i> Drive Folders ({{ folders.length }})
                <div class="pull-right" v-if="canEdit">
                    <button type="button" class="btn btn-sm btn-default" v-on:click="add_folder = !add_folder">
                        <i :class="'fa fa-'+(add_folder ? 'remove' : 'plus-circle')"></i> <span v-if="add_folder">Cancel</span> Add
                    </button>
                </div>
            </div>
            <div class="card-body">
                <div class="mb-3" v-if="add_folder">
                    <v-select
                        v-model="new_folder"
                        label="folder_name"
                        :filterable="false"
                        @search="onSearch"
                        :options="folderOptions"
                        :placeholder="`Search Drive Folders`"
                        :class="{'is-invalid': errors.folder_id}">
                        <template slot="no-options">
                            Search Drive Folders
                        </template>
                    </v-select>
                </div>

                <span v-if="loading">
                    <i class="fa fa-circle-o-notch fa-spin"></i> Loading
                </span>
                <ul class="list-unstyled" v-else>
                    <template v-if="folders.length > 0">
                       <li v-for="folder in folders" class="mb-2">
                           <button type="button" class="btn btn-xs btn-default" v-if="canEdit" v-on:click="deleteFolder(folder)">
                                <i class="fa fa-unlink text-danger"></i>
                            </button>

                           <router-link :to="`/drive/${folder.id}`">{{ folder.folder_name }}</router-link>
                       </li>
                   </template>
                   <li v-else>
                       -- No Folders for this {{ assetType }} --
                   </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {

            assetId: {
                type: Number,
                required: true,
            },

            assetType: {
                type: String,
                required: true,
            },

            canEdit: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                folders: [],
                folderOptions: [],
                errors: {},
                loading: false,
                add_folder: false,
                new_folder: null,
            }
        },

        watch: {
            //
            new_folder(new_val, old_val)
            {
                //Send it
                if(new_val === null || !new_val.id)
                {
                    return;
                }

                //SEnd it
                this.addFolder(new_val);
            }
        },

        methods: {
            //Search
            getFolders(){
                //Loading Indicator
                this.loading = true;

                //Send it
                this.$http.get('/drive/folders/asset/'+this.assetType+'/'+this.assetId)
                    .then(res => {
                        //Set the data
                        this.folders = res.data.folders;

                    })
                    .catch(response => {

                    })
                    .then(() => {
                        //This is alway hit
                        this.loading = false;
                    });
            },

            //Search
            onSearch(searchTerm, searchLoading){
                //Done loading
                searchLoading(true);

                //Send it
                this.$http.get('/drive/folders', {search: searchTerm})
                    .then(response => {
                        //Set the data
                        this.folderOptions = response.data.folders;

                        //Done loading
                        searchLoading(false);
                    });
            },

            addFolder(folder){
                //Make sure the folder has not already been added
                for (var i = this.folders.length - 1; i >= 0; i--)
                {
                    //Check it
                    if(this.folders[i].id == folder.id)
                    {
                        //Alert the uers
                        this.$toastr.warning('Folder: '+folder.folder_name+' is already linked to this '+this.assetType);

                        //Stop
                        return;
                    }
                }

                //Fire it
                this.$http.post('/drive/folders/asset/'+this.assetType+'/'+this.assetId+'/'+folder.id)
                    .then(res => {
                        //Add
                        this.folders.push(folder);

                        //REset
                        this.new_folder = null;
                        this.add_folder = false;

                        //Alert
                        //this.$toastr.s('Folder Linked to '+this.assetType);
                    })
                    .catch(response => {

                    })
                    .then(() => {
                        //This is alway hit
                        this.loading = false;
                    });
            },

            deleteFolder(folder){
                //Confirm
                if(!confirm('Are you sure you want to unlink this folder?'))
                {
                    return;
                }

                //Fire it
                this.$http.post('/drive/folders/asset/'+this.assetType+'/'+this.assetId+'/'+folder.id)
                    .then(res => {
                        //Remove it
                        for (var i = this.folders.length - 1; i >= 0; i--)
                        {
                            //Check it
                            if(this.folders[i].id == folder.id)
                            {
                                this.folders.splice(i, 1);
                            }
                        }

                        //Alert
                        this.$toastr.s('Folder Unlinked from '+this.assetType);
                    })
                    .catch(response => {

                    })
                    .then(() => {
                        //This is alway hit
                        this.loading = false;
                    });
            },
        },

        mounted() {
            //Get the folders
            this.getFolders();
        }
    }
</script>